import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchMultiSelect } from "components/input/colorSearchMultiSelect/ColorSearchMultiSelect";
import type { Dispatch } from "react";
import { getColorStatusValues } from "service/autocomplete-lookup";

export interface ColorStatusFilterProps {
  value?: Array<AutocompleteData>;
  onChange: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const ColorStatusFilter = ({
  value = [],
  onChange,
  t,
}: ColorStatusFilterProps) => {
  const options = getColorStatusValues();
  return (
    <ColorSearchMultiSelect
      options={options}
      onChange={onChange}
      value={value}
      label={t("filter_general_color_status")}
    />
  );
};
